import { baseUrl } from "../../../config.js";
import { EventBus } from "../../../eventbus";
import i18n from "../../../functions/i18next";

export default {
  /*
      Defines the data used by the component
    */
  data() {
    return {
      error: "",
      username: "",
      password: "",
      company: this.$store.state.company,
      user: this.$store.state.user,
    };
  },
  created() {},
  methods: {
    submit() {
      event.preventDefault();
      let formData = new FormData();
      formData.append("username", this.username);
      formData.append("password", this.password);
      this.$axios
        .post(baseUrl + "/login", formData)
        .then((response) => {
          if (response.data) {
            this.$store.state.user = response.data;
            this.user = response.data;

            this.$axios.defaults.params["key"] = response.data.key;
            localStorage.setItem(
              this.$store.state.company + "_" + "user",
              JSON.stringify(response.data)
            );
            this.$router.go();
          } else {
            this.error = i18n.t("login.credentials_match_error");
          }
        })
        .catch((thrown) => {
          if (axios.isCancel(thrown)) {
            this.error = i18n.t("common.something_went_wrong");
          } else {
            this.error = i18n.t("common.something_went_wrong");
          }
        });
    },
    logout() {
      this.$store.state.user = null;
      this.user = null;
      this.$axios.defaults.params["key"] = null;
      localStorage.setItem(
        this.$store.state.company + "_" + "user",
        JSON.stringify(null)
      );
      localStorage.setItem(
        this.$store.state.company + "_" + "folder_spaces",
        JSON.stringify(null)
      );
      localStorage.setItem(
        this.$store.state.company + "_" + "folder_myspace",
        JSON.stringify(null)
      );
      this.$router.push("/" + this.$store.state.company);

      //push logout
      if (this.$store.state.user) {
        const formData = new FormData();

        formData.append("key", this.$store.state.user.key);

        this.$axios.post(`${baseUrl}/logout`, formData);
      }

      EventBus.$emit("login"); //Trust me this has te be here ;)
    },
    showPassword(event) {
      /**
       * When the button is clicked, stay on the same page
       */
      event.preventDefault();

      /**
       * currentParent = the parent of the clicked button
       * passwordField = the password field
       * passwordType = the type of the password field
       *
       * @type {HTMLElement}
       */
      let currentParent = event.currentTarget.parentElement;
      let passwordField = currentParent.querySelector("#password");
      let passwordType = passwordField.getAttribute("type");

      /**
       * When the button is clicked toggle the type of the password field between text and password
       * -- When the type is password, the password will not be readable and ••• will be shown
       * -- When the type is test, the password will be readable
       */
      if (passwordType == "password") {
        passwordField.setAttribute("type", "text");
      } else {
        passwordField.setAttribute("type", "password");
      }
    },
  },
};
